function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".searchIcon-1{fill:#37beb7;stroke:#37beb7;}.searchIcon-1,.searchIcon-2{stroke-width:1.4px;}.searchIcon-2{fill:#ffbe54;stroke:#ffbe54;}.searchIcon-3{fill:#16224a;fill-rule:evenodd;}.searchIcon-3,.searchIcon-4{stroke:#16224a;}.searchIcon-4{fill:none;stroke-width:1.2px;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-1",
  cx: 19.76,
  cy: 18.61,
  r: 1.96
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-2",
  cx: 37.55,
  cy: 18.61,
  r: 1.96
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-1",
  cx: 55.32,
  cy: 18.61,
  r: 1.96
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-1",
  cx: 55.32,
  cy: 36.39,
  r: 1.96
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-2",
  cx: 55.32,
  cy: 54.26,
  r: 1.96
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-1",
  cx: 37.55,
  cy: 54.26,
  r: 1.96
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-1",
  cx: 19.76,
  cy: 54.09,
  r: 1.96
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-2",
  cx: 19.76,
  cy: 36.39,
  r: 1.96
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "shape1",
  className: "searchIcon-3",
  d: "M9.62,61.09a36.59,36.59,0,0,1,56.1-47,36.34,36.34,0,0,1-.7,47.8l11.7,13.9a1.09,1.09,0,0,1-.1,1.5L70,82.79a1,1,0,0,1-1.4-.2l-11.7-13.9A36.67,36.67,0,0,1,9.62,61.09Zm47.4-.4A30.17,30.17,0,1,0,14.52,57,30.15,30.15,0,0,0,57,60.69Z",
  transform: "translate(-0.5 -0.51)"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-4",
  cx: 19.41,
  cy: 19.33,
  r: 2.9
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-4",
  cx: 54.91,
  cy: 37.08,
  r: 2.9
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-4",
  cx: 54.91,
  cy: 19.33,
  r: 2.9
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-4",
  cx: 19.41,
  cy: 37.08,
  r: 2.9
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-4",
  cx: 37.16,
  cy: 19.33,
  r: 2.9
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-4",
  cx: 37.16,
  cy: 54.83,
  r: 2.9
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-4",
  cx: 54.91,
  cy: 54.83,
  r: 2.9
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  className: "searchIcon-4",
  cx: 19.41,
  cy: 54.83,
  r: 2.9
});

var _ref20 = /*#__PURE__*/React.createElement("line", {
  className: "searchIcon-4",
  x1: 21.54,
  y1: 21.46,
  x2: 52.78,
  y2: 52.88
});

var _ref21 = /*#__PURE__*/React.createElement("line", {
  className: "searchIcon-4",
  x1: 21.36,
  y1: 34.95,
  x2: 35.03,
  y2: 21.46
});

var _ref22 = /*#__PURE__*/React.createElement("line", {
  className: "searchIcon-4",
  x1: 37.16,
  y1: 22.22,
  x2: 37.16,
  y2: 51.93
});

var _ref23 = /*#__PURE__*/React.createElement("line", {
  className: "searchIcon-4",
  x1: 52.78,
  y1: 21.46,
  x2: 21.54,
  y2: 52.7
});

var _ref24 = /*#__PURE__*/React.createElement("line", {
  className: "searchIcon-4",
  x1: 38.88,
  y1: 20.97,
  x2: 52.78,
  y2: 35.13
});

var _ref25 = /*#__PURE__*/React.createElement("line", {
  className: "searchIcon-4",
  x1: 37.87,
  y1: 22.12,
  x2: 53.75,
  y2: 52.18
});

var _ref26 = /*#__PURE__*/React.createElement("line", {
  className: "searchIcon-4",
  x1: 22.31,
  y1: 37.08,
  x2: 52.02,
  y2: 37.08
});

var _ref27 = /*#__PURE__*/React.createElement("line", {
  className: "searchIcon-4",
  x1: 22.31,
  y1: 53.89,
  x2: 52.78,
  y2: 39.21
});

var _ref28 = /*#__PURE__*/React.createElement("line", {
  className: "searchIcon-4",
  x1: 20.35,
  y1: 22.05,
  x2: 35.03,
  y2: 52.7
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search1",
    viewBox: "0 0 76.97 82.98",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Search.e4aa31d9.svg";
export { ForwardRef as ReactComponent };